import { render, staticRenderFns } from "./system-item.vue?vue&type=template&id=3e2ef744"
import script from "./system-item.vue?vue&type=script&lang=js"
export * from "./system-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports